import React from "react";
import Expander from "../../Expander";
import { getVarsoUrl } from "../../../common/helpers/helpers";
import PublicationLinks from "../../Publications/components/PublicationLinks";
import { createTableHeader } from "../helpers";
import helpers from "../../../common/utils/utils";
import {
  chemicalRelationsTableHeaders,
  chemicalRelationsGeneTableHeaders,
} from "./chemicalRelationsHelpers";

const variantAnnotationUrl = "https://www.pharmgkb.org/variantAnnotation/";
const chemicalUrl = "https://www.pharmgkb.org/chemical/";

const getChemicalRelationsRow = (item, key, isGene, expandRow) => {
  const rows = [];
  if (item) {
    const pDynamic =
      item.pharmacodynamic !== undefined &&
      item.pharmacodynamic !== null &&
      (item.pharmacodynamic ? "Yes" : "No");
    const pKinetic =
      item.pharmacokinetic !== undefined &&
      item.pharmacokinetic !== null &&
      (item.pharmacokinetic ? "Yes" : "No");
    const sign =
      item.significant !== undefined &&
      item.significant !== null &&
      (item.significant ? "Yes" : "No");
    const row = (
      <tr
        className="tw-border-t tw-border-solid tw-border-gray-200 tw-break-words"
        key={key}
      >
        <td className="tw-text-left tw-p-2.5">
          {item.id && item.name ? (
            <a href={getVarsoUrl(chemicalUrl + item.id)} target="_blank">
              {(item.name &&
                helpers.capitalizeFirstLetter(item.name.toLowerCase())) ||
                "-"}
            </a>
          ) : (
            item.name || "-"
          )}
        </td>
        <td className="tw-text-center tw-p-2.5">
          {(item.association &&
            helpers.capitalizeFirstLetter(item.association.toLowerCase())) ||
            "-"}
        </td>
        {!isGene && <td className="tw-text-center tw-p-2.5">{sign || "-"}</td>}
        {!isGene && (
          <td className="tw-text-center tw-p-2.5">
            {(item.drug_variant_relation &&
              helpers.capitalizeFirstLetter(
                item.drug_variant_relation.toLowerCase()
              )) ||
              "-"}
          </td>
        )}
        <td className="tw-text-center tw-p-2.5">{pDynamic || "-"}</td>
        <td className="tw-text-center tw-p-2.5">{pKinetic || "-"}</td>
        <td className="tw-text-center tw-p-2.5">
          {item.pub_med_references ? (
            <PublicationLinks ids={item.pub_med_references} />
          ) : (
            "-"
          )}
        </td>
        {!isGene && (
          <td className="tw-text-center tw-p-2.5">
            {item.annotation_id ? (
              <a
                href={getVarsoUrl(variantAnnotationUrl + item.annotation_id)}
                target="_blank"
              >
                {item.annotation_id}
              </a>
            ) : (
              "-"
            )}
          </td>
        )}
        {!isGene && (
          <td className="tw-text-center tw-p-2.5">
            {item.curator_notes ? (
              <a onClick={() => expandRow(item)}>
                {item.expanded ? "Collapse notes" : "Expand notes"}
              </a>
            ) : (
              "-"
            )}
          </td>
        )}
      </tr>
    );

    rows.push(row);
  }
  if (item.expanded) {
    const expandedRow = (
      <tr
        className="tw-border-t tw-border-solid tw-border-gray-200 tw-break-words"
        key={`expanded_${item.key}`}
      >
        <td className="tw-p-2.5" colSpan="9">
          {item.curator_notes}
        </td>
      </tr>
    );
    rows.push(expandedRow);
  }
  return rows;
};

const createTableRows = (items, isGene, expandRow) => {
  const rows = [];
  items.forEach((item, i) => {
    const key = `${i}${new Date()}`;
    rows.push(getChemicalRelationsRow(item, key, isGene, expandRow));
  });
  return rows;
};

export const getChemicalRelationsTable = (items, isGene, expandRow) => {
  if (Array.isArray(items) && items.length !== 0) {
    const tableHeader = isGene
      ? createTableHeader(chemicalRelationsGeneTableHeaders)
      : createTableHeader(chemicalRelationsTableHeaders);
    const expanderCols = isGene
      ? chemicalRelationsGeneTableHeaders.length
      : chemicalRelationsTableHeaders.length;
    const rows = createTableRows(items, isGene, expandRow);

    const result = (
      <table className="tw-w-full tw-border-collapse tw-border-t tw-border-solid tw-border-gray-200 tw-break-words tw-font-saphetor">
        {tableHeader}
        <Expander showMore="10" columns={expanderCols} component="tbody">
          {rows}
        </Expander>
      </table>
    );
    return result;
  }
  return null;
};
